import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { HeaderComponent } from './header/header.component';
import { Http, HttpModule } from '@angular/http';  // <-Add here
import { fakeBackendProvider } from './_helpers';
import { AlertComponent } from './_directives';
import { AuthGuard } from './_guards';
import { JwtInterceptor, ErrorInterceptor,FilterlistPipe } from './_helpers';
import { AlertService, AuthenticationService, UserService,PushNotificationsService } from './_services';
//import { HomeComponent } from './home';
import { LoginComponent } from './login';
import { ForgotPasswordComponent } from './forgotpassword/forgotpassword.component';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { GridModule } from '@progress/kendo-angular-grid';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { FileUploadModule } from 'ng2-file-upload';
import { APP_BASE_HREF } from '@angular/common';
import { DialogsModule } from '@progress/kendo-angular-dialog';
import { bootstrap } from 'bootstrap';
import { ProgressBarModule } from 'primeng/progressbar';
import { Configuration } from './configuration/configurations';
import { DataTableModule } from 'angular-6-datatable';
import { NgDatepickerModule } from 'ng2-datepicker';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { DeviceDetectorModule } from 'ngx-device-detector';
import { DataTablesModule } from 'angular-datatables';
import { ResetpasswordComponent } from './resetpassword/resetpassword.component';
import { NotifierModule ,NotifierOptions} from 'angular-notifier';
import { DashboardComponent } from './dashboard/dashboard.component';
import { FooterComponent } from './footer/footer.component';
import { NgxCaptchaModule } from 'ngx-captcha';
import { AllocatecallhistoryComponent } from './allocatecallhistory/allocatecallhistory.component';
import {AllocatehistoryComponent} from './allocatehistory/allocatehistory.component';
import { AddTaskTimeComponent} from './addtasktime/addtasktime.component';
import { UnallocatecalllogComponent } from './unallocatecalllog/unallocatecalllog.component';
import { ContactusComponent } from './contactus/contactus.component';
import { AgGridModule } from "ag-grid-angular";
import {ChildMessageRenderer} from './unallocatecalllog/cellRenderer';
import {ChildCommentRenderer} from './allocatecallhistory/cellRenderer';
import {AutocompleteLibModule} from 'angular-ng-autocomplete';
import { Ng2SearchPipeModule } from 'ng2-search-filter';
import { PrivacypolicyComponent } from './privacypolicy/privacypolicy.component';
import { TermsconditionComponent } from './termscondition/termscondition.component';
import { NgSelectModule } from 'ng-custom-select';
import { TooltipModule } from 'ng2-tooltip-directive';
import { OwlDateTimeModule, OwlNativeDateTimeModule } from 'ng-pick-datetime'; 
import {CalendarModule} from 'primeng/calendar';
import { DateFilterPipe } from './date-filter.pipe';
import { CommonModule, DatePipe } from '@angular/common';
import { UnauthenticationuserComponent } from './unauthenticationuser/unauthenticationuser.component';

const customNotifierOptions: NotifierOptions = {
  position: {
		horizontal: {
			position: 'middle',
			distance: 12
		},
		vertical: {
			position: 'top',
			distance: 12,
			gap: 10
		}
	},
  theme: 'material',
  behaviour: {
    autoHide: 5000,
    onClick: 'hide',
    onMouseover: 'pauseAutoHide',
    showDismissButton: true,
    stacking: 4
  },
  animations: {
    enabled: true,
    show: {
      preset: 'slide',
      speed: 300,
      easing: 'ease'
    },
    hide: {
      preset: 'fade',
      speed: 300,
      easing: 'ease',
      offset: 50
    },
    shift: {
      speed: 300,
      easing: 'ease'
    },
    overlap: 150
  }
};
@NgModule({
  declarations: [
    //DateFilterPipe,
    FilterlistPipe,
    AppComponent,
    SidebarComponent,
    HeaderComponent,
   // HomeComponent,
    LoginComponent,
    AlertComponent,
    ForgotPasswordComponent,
   ResetpasswordComponent,
   DashboardComponent,
   FooterComponent,
   AllocatecallhistoryComponent,
   AllocatehistoryComponent,
   AddTaskTimeComponent,
   UnallocatecalllogComponent,
   ContactusComponent,
   ChildMessageRenderer,
   ChildCommentRenderer,
   PrivacypolicyComponent,
   TermsconditionComponent,
   UnauthenticationuserComponent
   
   ],
  imports: [
    NgSelectModule,
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    HttpModule,
    FormsModule,
    ReactiveFormsModule,
    InputsModule,
    BrowserAnimationsModule,
    ButtonsModule,
    GridModule,
    DropDownsModule,
    FileUploadModule,
    DialogsModule,
    ProgressBarModule,
    DataTableModule,
    NgDatepickerModule,
    DialogModule,
    ButtonModule,
    DeviceDetectorModule.forRoot(),
    DataTablesModule,
    NotifierModule.withConfig(customNotifierOptions),
    NgxCaptchaModule,
    AgGridModule.withComponents([ChildMessageRenderer,ChildCommentRenderer]),
    AutocompleteLibModule,
    Ng2SearchPipeModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    CalendarModule,
TooltipModule 

  ],
  providers: [
    
    AuthGuard,
    AlertService,
    PushNotificationsService,
    AuthenticationService,
    UserService,
    Configuration,
    // UnallocatecalllogComponent,
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    { provide: APP_BASE_HREF, useValue: '' },

    // provider used to create fake backend
    fakeBackendProvider,
    //DatePipe
  ],
  bootstrap: [AppComponent]
})
export class AppModule { bootstrap }
